module.exports = __webpack_public_path__ + "img/130ne.5b631b7d.svg";